import React from 'react';
import './Scholarships.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const Scholarships = () => {
  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-container light-theme">
        <div className="container">
        <header className="header">
          <h1>Scholarships</h1>
          <p>Making quality education accessible to all</p>
        </header>

        <div className="scholarshipCategories">
          <div className="scholarshipCard merit">
            <h3>Merit Scholarships</h3>
            <div className="scholarshipContent">
              <p>For students with outstanding academic performance</p>
              <ul>
                <li>Full tuition waiver for top 1% students</li>
                <li>50% tuition waiver for top 5% students</li>
                <li>25% tuition waiver for top 10% students</li>
              </ul>
            </div>
          </div>

          <div className="scholarshipCard needBased">
            <h3>Need-Based Financial Aid</h3>
            <div className="scholarshipContent">
              <p>Supporting students from economically weaker sections</p>
              <ul>
                <li>Full financial support for eligible students</li>
                <li>Books and study materials support</li>
                <li>Hostel fee concession</li>
              </ul>
            </div>
          </div>

          <div className="scholarshipCard sports">
            <h3>Sports Excellence</h3>
            <div className="scholarshipContent">
              <p>For outstanding athletes and sports persons</p>
              <ul>
                <li>Full scholarship for national level players</li>
                <li>75% scholarship for state level players</li>
                <li>Special training facilities</li>
              </ul>
            </div>
          </div>
        </div>

        <section className="applicationProcess">
          <h2>How to Apply</h2>
          <div className="steps">
            <div className="step">
              <span className="stepNumber">1</span>
              <p>Submit scholarship application form</p>
            </div>
            <div className="step">
              <span className="stepNumber">2</span>
              <p>Provide required documents</p>
            </div>
            <div className="step">
              <span className="stepNumber">3</span>
              <p>Interview with scholarship committee</p>
            </div>
          </div>
        </section>
      </div>
      </div>
      <Footer />
    </div>
  );
};

export default Scholarships;
